import styled from '@emotion/styled'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import {COLORS} from '../constants'

/** Tinted info panel that holds the hierarchy explanation text. */
export const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid ${COLORS.infoBorder};
  border-radius: 12px;
  background-color: ${COLORS.infoBg};
  color: ${COLORS.infoText};
  font-size: 13px;
  line-height: 1.5;
`

/** Leading info icon, sized and aligned to the first line of the banner text. */
export const BannerIcon = styled(InfoOutlined)`
  flex-shrink: 0;
  margin-top: 1px;
  font-size: 18px;
`

/** Bold lead-in phrase at the start of the banner sentence. */
export const BannerTitle = styled.span`
  font-weight: 600;
`
